'use es6';

import get from 'transmute/get';
export const getFirstName = user => user.get('firstName') || user.get('first_name');
export const getLastName = user => user.get('lastName') || user.get('last_name');
export const getEmail = user => user.get('email');
export const getId = get('id');